export default {
    general: {
        add:            'Add',
        edit:           'Edit',
        delete:         'Delete',
        cancel:         'Cancel',
        save:           'Save',
        confirm:        'Confirm',
        confirm_action: 'Confirm Action',
        sign_out:       'Sign out',
        more_info:      'More information',
        name:           'Name',
        refresh:        'Refresh',
        actions:        'Actions',
        status:         'Status',
        details:        'Details',
        type:           'Type',
        overview:       'Overview',
        settings:       'Settings',
    },
    brand: {
        product_name: 'NervusEye',
        product_line: 'MONITOR',
        vendor:       'by iT TEAM d.o.o.',
        tagline:      'Network Operations Management',
    },
    search: {
        input_placeholder:   'Search devices, IP addresses, MACs, sensors, subnets...',
        placeholder_short:   'Search infrastructure...',
        tooltip:             'Global Search (Cmd + K / Ctrl + K)',
        quick_navigation:    'Quick Navigation',
        category_all:        'All',
        category_devices:    'Devices',
        category_sensors:    'Sensors',
        category_hosts:      'IPAM Hosts',
        category_subnets:    'Subnets',
        category_navigation: 'Navigation',
        no_results_title:    'No results found for',
        no_results_desc:     'Try searching by hostname, management IP, MAC address, switch port, or subnet CIDR.',
        hint_navigate:       'to navigate',
        hint_open:           'to open',
    },
    sla: {
        title:                   'SLA, Availability & Uptime Reports',
        subtitle:                'Contractual SLA tracking, fleet uptime percentage, MTTR/MTTF metrics and outage durations.',
        period:                  'Period',
        target:                  'Target SLA',
        print_pdf:               'Print / PDF Report',
        export_csv:              'Export CSV',
        search_placeholder:      'Filter by device, IP, vendor...',
        fleet_availability:      'Fleet Availability',
        compliance_rate:         'SLA Compliance Rate',
        compliant_devices:       'Compliant Devices',
        breached_devices:        'Breached Devices',
        total_outages:           'Total Outages',
        fleet_mttr:              'Fleet MTTR',
        devices_breakdown:       'Device SLA Breakdown',
        devices_matching_filter: 'devices matching current filter',
        no_devices_found:        'No devices found',
        try_changing_filter:     'Try changing search filters or selecting another period.',
        col_device:              'Device',
        col_availability:        'Availability',
        col_status:              'SLA Status',
        col_outages:             'Outages',
        col_downtime:            'Total Downtime',
        col_mttr:                'MTTR',
        col_mttf:                'MTTF',
        col_remaining:           'Remaining Allowed',
    },
    // Short labels for the navigation row; nav.* stays the full section name
    nav_short: {
        dashboard:     'Dashboard',
        devices:       'Devices',
        topology:      'Topology',
        ipam:          'IPAM',
        documentation: 'Docs',
        security:      'Security',
        syslog:        'Syslog',
        events:        'Events',
        tools:         'Tools',
        sla:           'SLA',
        templates:     'Templates',
        users:         'Users',
        settings:      'Settings',
        about:         'About',
    },
    nav: {
        dashboard:      'Dashboard',
        devices:        'Devices',
        topology:       'Network Topology',
        ipam:           'IPAM & Inventory',
        documentation:  'Documentation',
        security:       'Port Security & Rogue Detection',
        syslog:         'Syslog & SNMP Traps',
        events:         'Events & Outages',
        tools:          'Network Tools',
        sla:            'SLA Reports',
        sensors:        'Sensors',
        administration: 'Administration',
        templates:      'Templates',
        users:          'User Management',
        settings:       'Global Settings',
        changelog:      'Audit Change Log',
        about:          'About & Help',
    },
    common: {
        cancel:   'Cancel',
        close:    'Close',
        select:   'Select',
        deselect: 'Deselect',
        clear:    'Clear',
    },
    languages: {
        en:              'English',
        hr:              'Hrvatski',
        sl:              'Slovenščina',
        de:              'Deutsch',
        fr:              'Français',
        change_language: 'Change Language',
    },
    status: {
        up:           'Online (UP)',
        down:         'Offline (DOWN)',
        warning:      'Warning',
        acknowledged: 'Acknowledged',
        paused:       'Paused',
        unknown:      'Unknown',
    },
    dashboard: {
        title:                'Operations Dashboard',
        subtitle:             'Real-time network telemetry and infrastructure health',
        total_devices:        'Total Devices',
        online_devices:       'Online Devices',
        warning_devices:      'Warning / Degraded',
        offline_devices:      'Offline / Critical',
        total_sensors:        'Active Sensors',
        network_health:       'Network Health',
        all_systems_ok:       'All monitored devices and sensors are operational.',
        active_alerts:        'Active Alerts & Outages',
        active_alerts_desc:   'Devices and sensors currently requiring attention',
        recent_devices:       'Infrastructure Monitored Devices',
        explore_tree:         'Open Device Tree',
        inspect:              'Inspect',
        auto_refresh:         'Auto refresh',
        arrange_graphs:       'Edit / Arrange Graphs',
        done_arranging:       'Done Arranging',
        arrange_hint:         'Arrange Mode: Add multiple telemetry graphs, drag cards or use arrows to reorder, and customize column widths.',
        grid_cols:            'Columns:',
        save_layout:          'Save Layout',
        select_sensor_to_add: 'Select a sensor to add to Live Telemetry...',
        add_graph:            'Add Graph',
        layout_saved:         'Telemetry graph layout saved',
        pause_sensor:         'Pause Sensor',
        top_metrics_title:    'Performance & Top Hosts',
        top_metrics_subtitle: 'Real-time infrastructure insights across resource consumption, traffic, and stability',
        widgets_active:       'active',
        top_cpu:              'Top CPU Load',
        top_cpu_desc:         'Devices with highest processor utilization percentage',
        top_ram:              'Top RAM Usage',
        top_ram_desc:         'Devices with highest memory percentage and footprint',
        top_uptime:           'Availability & Uptime',
        longest_uptime:       'Longest Uptime (Stability)',
        recently_rebooted:    'Recently Rebooted',
        top_ping:             'Top Latency / Ping',
        top_ping_desc:        'Devices and services with highest round-trip response time (RTT)',
        top_traffic:          'Top Network Traffic',
        top_port_errors:      'Port Errors & Buffer Drops',
        no_port_errors:       'No port errors or buffer drops detected',
        top_bgp:              'BGP Peering Sessions',
        top_temperature:      'Top Temperature & Hardware',
        top_storage:          'Top Storage / Disk',
        view_mode_grid:       'Grid',
        view_mode_tabs:       'Tabs',
        customize_widgets:    'Customize Widgets',
        hosts_ranked:         'ranked hosts',
        no_data:              'No data available',
    },
    tree: {
        search_placeholder: 'Search devices, IP, sensors...',
        filter_all:         'All',
        total_items:        'items',
        no_nodes_found:     'No nodes matching criteria',
        add_group:          'Add Group',
        add_folder:         'Add Folder',
        add_device:         'Add Device',
        add_sensor:         'Add Sensor',
        root_title:         'Infrastructure Tree',
        devices_selected:   '{count} selected',
        drag_to_folder:     'Drag to folder to move',
        devices_moved:      'Successfully moved {count} device(s) to {target}',
        move_failed:        'Failed to move devices',
        back_to_tree:       'Back to tree',
    },
    devices: {
        title:                'Device Explorer',
        add_device:           'Add Device',
        edit_device:          'Edit Device',
        delete_device:        'Delete Device',
        confirm_delete:       'Are you sure you want to delete this device and all its sensors?',
        name:                 'Device Name',
        name_placeholder:     'e.g. Core-Switch-01',
        hostname_ip:          'Hostname / IP',
        polling_interval:     'Polling Interval (s)',
        snmp_enabled:         'Enable SNMP',
        snmp_enabled_hint:    'Query MIB metrics and auto-discover interfaces',
        snmp_version:         'SNMP Version',
        snmp_port:            'SNMP Port',
        snmp_community:       'Community String',
        poll_now:             'Poll Now',
        polling_started:      'Manual polling triggered',
        snmp_walk:            'SNMP Walk',
        snmp_walk_title:      'SNMP Walk Diagnostic',
        run_walk:             'Run Walk',
        walking_mibs:         'Walking OID tree...',
        no_walk_results:      'No OID results returned',
        device_details:       'Device Details',
        device_sensors:       'Configured Sensors',
        sensors_count:        'Sensors',
        vendor:               'Vendor',
        model:                'Model',
        last_polled:          'Last Polled',
        no_devices_in_folder: 'No devices in this group/folder',
        select_node_hint:     'Select a group, folder, or device from the tree on the left to view details.',
    },
    discovery: {
        title:               'Interface Discovery & Autodiscovery',
        scan_interfaces:     'Scan Interfaces',
        run_autodiscovery:   'Run Full Autodiscovery',
        select_all:          'Select All',
        deselect_all:        'Deselect All',
        add_selected:        'Add Selected as Sensors',
        scanning_hint:       'Querying device SNMP ifTable / ifXTable...',
        no_interfaces:       'No interfaces found. Ensure SNMP is responding on the device.',
        description:         'Description / Alias',
        speed:               'Speed',
        discover_interfaces: 'Discover Interfaces',
        group_by_type:       'Group devices into folders by device type',
        folders_preview:     'Folders to be filled / created:',
    },
    sensors: {
        add_sensor:          'Add Sensor',
        edit_sensor:         'Edit Sensor',
        edit_sensor_title:   'Edit Sensor Settings',
        type:                'Sensor Type',
        name:                'Sensor Name',
        name_placeholder:    'e.g. Ping Latency',
        interval:            'Interval (s)',
        enabled:             'Sensor Active / Enabled',
        enabled_hint:        'When disabled, poller pauses polling this sensor',
        oid:                 'SNMP OID',
        interface_index:     'Interface Index',
        last_reading:        'Last Reading',
        last_checked:        'Last Checked',
        confirm_delete:      'Are you sure you want to delete this sensor?',
        no_sensors_assigned: 'No sensors assigned to this device yet',
        add_sensor_success:  'Sensor created successfully',
        add_sensor_error:    'Failed to create sensor',
    },
    metrics: {
        more_ranges:   'More time ranges',
        custom_range:  'Custom range',
        range_from:    'From',
        range_to:      'To',
        range_invalid: 'Start must be before end',
        apply:         'Apply',
        title:      'Live Telemetry & Metrics',
        current:    'Current',
        avg:        'Average',
        min:        'Min',
        max:        'Max',
        p95:        '95th percentile',
        p95_hint:   '95th percentile of 5-minute samples over the selected range, as used for traffic reports',
        no_data:    'No metric readings available for this period',
    },
    templates: {
        title:                'SNMP Templates & MIBs',
        subtitle:             'Device performance templates and standard vendor profiles',
        add_template:         'Add Template',
        edit_template:        'Edit Template',
        import_template:      'Import Templates',
        import_template_hint: 'Paste JSON template structure to import templates in bulk.',
        import_mib:           'Import MIB',
        import_mib_hint:      'Upload RFC or vendor MIB file content to populate OID catalogs.',
        export_all:           'Export All (JSON)',
        export:               'Export',
        search_placeholder:   'Search templates by name, vendor...',
        templates_count:      'templates',
        no_templates_found:   'No SNMP templates found',
        template_oids:        'Configured Template OIDs',
        add_oid:              'Add OID',
        no_oids_added:        'No OIDs defined in this template yet.',
        expand_all:           'Expand All',
        collapse_all:         'Collapse All',
        what_oid_does:        'What OID Does (Functionality)',
        metric_name:          'Metric Name',
        copy_oid:             'Copy OID',
        filter_metrics:       'Filter metrics in template...',
    },
    users: {
        title:            'User Accounts',
        subtitle:         'Manage operator access and role permissions',
        add_user:         'Add User',
        edit_user:        'Edit User',
        accounts:         'Registered Accounts',
        username:         'Username',
        role:             'Role',
        password:         'Password',
        change_password:  'Change Password',
        old_password:     'Current Password',
        new_password:     'New Password',
        confirm_password: 'Confirm New Password',
        no_users_found:   'No user accounts found',
    },
    settings: {
        title:                 'System Settings',
        subtitle:              'Global configuration, audit logs, and database backup',
        general_tab:           'General',
        general_preferences:   'General Preferences',
        appearance:            'Appearance',
        appearance_info:       'Colour theme of this browser. Pages, menus and tabs stay the same; only colours, borders and the font change.',
        theme_company:         'Company',
        theme_company_desc:    'NervusEye colours: zinc grey and orange',
        theme_classic:         'Classic',
        theme_classic_desc:    'The first ZeroNMS look: charcoal, slate and blue',
        root_node_name:        'Root Node Display Name',
        default_traffic_unit:  'Default Traffic Bandwidth Unit',
        autodiscover_interval:  'Autodiscovery Interval',
        autodiscover_hint:      'How often every SNMP device is searched again for new ports, BGP peers, PPPoE and hardware sensors. Sensors you delete are not added back.',
        autodiscover_off:       'Off',
        autodiscover_hourly:    'Every hour',
        autodiscover_every:     'Every {n} hours',
        audit_logs:            'Audit & Change Logs',
        timestamp:             'Timestamp',
        action:                'Action Performed',
        backup_recovery:       'Backup & Recovery',
        console_tab:           'Console Apps',
        console_downloads:     'Console Downloads',
        console_info:          'Native desktop app that connects to several NervusEye MONITOR servers at once and shows their device trees, alarms and sensor history.',
        console_req_macos:     'macOS 14 Sonoma or later, Apple silicon and Intel',
        console_req_windows:   'Windows 10 (1809) or later, 64-bit',
        console_req_android:   'Android 10 or later',
        console_ios_note:      'iPhone and iPad: the console is distributed through TestFlight; ask your administrator for an invitation.',
        console_build:         'Build',
        console_size:          'Size',
        console_published:     'Published',
        console_download:      'Download {file}',
        console_unavailable:   'Not available yet',
        console_not_published: 'No installer has been published to this server yet.',
        console_loading:       'Loading...',
        console_connect:       'Connect to This Server',
        console_server_address:'Server address',
        console_step_install:  'Install the console and open it.',
        console_step_add:      'Choose Add Server and paste the server address above.',
        console_step_login:    'Sign in with your NervusEye MONITOR username and password.',
        run_backup:            'Run Backup Now',
        restore:               'Restore',
        notifications_tab:     'Alerts & Notifications',
        notifications_title:   'Alerting & Notification Channels',
        telegram_title:        'Telegram Alerting Bot',
        telegram_desc:         'Send instant push notifications to your Telegram direct message or IT team group chat.',
        telegram_enable:       'Enable Telegram Alerts',
        telegram_bot_token:    'Telegram Bot Token',
        telegram_token_help:   "Obtain from {'@'}BotFather on Telegram (e.g. 123456789:ABCdefGhI...)",
        telegram_chat_id:      'Telegram Chat ID',
        telegram_chat_help:    'Target Chat or Group ID (e.g. -100123456789 for supergroup)',
        telegram_test_btn:     'Send Test Telegram Alert',
        webhook_title:         'Webhook Integration',
        webhook_desc:          'Stream alert JSON payloads to Discord, Slack, Microsoft Teams, or custom HTTP endpoints.',
        webhook_enable:        'Enable Webhook Alerts',
        webhook_url:           'Webhook URL Endpoint',
        webhook_url_help:      'Incoming webhook URL (e.g. https://discord.com/api/webhooks/... or Slack webhook)',
        webhook_type:          'Webhook Service Type',
        webhook_test_btn:      'Send Test Webhook Alert',
        email_title:           'Email (SMTP) Notifications',
        email_desc:            'Send rich HTML alert emails with color-coded status badges and device details.',
        email_enable:          'Enable Email Alerts',
        smtp_host:             'SMTP Server Host',
        smtp_port:             'SMTP Port',
        smtp_username:         'SMTP Username',
        smtp_password:         'SMTP Password',
        smtp_from:             'Sender Address (From)',
        smtp_to:               'Recipient Addresses (To)',
        smtp_tls:              'Use TLS / STARTTLS Encryption',
        email_test_btn:        'Send Test Email',
        trigger_rules_title:   'Alert Triggering & Flapping Rules',
        flapping_protection:   'Flapping Protection (Consecutive Failures)',
        flapping_help:         'Require multiple consecutive poll failures before alerting to avoid false alarms from network jitter.',
        alert_cooldown:        'Alert Cooldown / Repeat Interval',
        cooldown_help:         'Minutes to wait before repeating notifications for an ongoing incident (0 = only on state change).',
        notify_down:           'Notify on Outage / DOWN',
        notify_down_help:      'Send immediate alert when a device or sensor status transitions to DOWN',
        notify_warning:        'Notify on WARNING limit',
        notify_warning_help:   'Send alert when custom sensor exceeds warning threshold',
        notify_recovery:       'Notify on RECOVERY / UP',
        notify_recovery_help:  'Send recovery notification when a downed component returns to UP state',
    },
    events: {
        title:            'Outage & Event History',
        subtitle:         'Chronological log of network outages, warnings, and recovery events',
        tab:              'Events & Outages',
        total_outages:    'Total Outages',
        active_outages:   'Active Outages',
        resolved_outages: 'Resolved Incidents',
        warnings:         'Warning Events',
        filter_device:    'Search device, IP, or sensor...',
        filter_status:    'Status',
        filter_resolved:  'State',
        all_statuses:     'All Statuses',
        all_states:       'All States',
        active_only:      'Active Incidents',
        resolved_only:    'Resolved Only',
        started_at:       'Started At',
        ended_at:         'Ended At',
        duration:         'Duration',
        component:        'Component / Sensor',
        reason:           'Root Cause / Message',
        active:           'Active Outage',
        resolved:         'Resolved',
        no_events:        'No outage events recorded matching the criteria.',
        ongoing:          'Ongoing',
    },
    layout: {
        open_menu:  'Open menu',
        more:       'More',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'Unauthorized',
        on_add:        'Error while adding',
        on_edit:       'Error while updating',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully updated',
    },
    validation: {
        required: 'This field is required',
        email:    'Invalid email address',
    },
    ipam: {
        title:              'IPAM & Inventory',
        subtitle:           'Centralized IP address space management, auto-discovered subnets, VLANs, and active connected hosts',
        export_csv:         'Export CSV',
        refresh:            'Refresh',
        subnets:            'Subnets',
        active_hosts:       'Active Hosts',
        free_ips:           'Free IPs',
        total_space:        'Total Address Space',
        gateways:           'Gateways',
        subnets_count:      'Subnets ({count})',
        filter_subnets:     'Filter subnets (CIDR, VLAN)...',
        rows_per_page:      'Rows:',
        all:                'All',
        all_subnets:        'All Subnets',
        all_subnets_desc:   'Aggregated inventory across all subnets and VLANs',
        used_free:          '{used} used / {free} free',
        gateway_prefix:     'GW: {ip}',
        host_table:         'Host Table',
        visual_matrix:      'Visual Matrix',
        search_placeholder: 'Search IP, MAC, Vendor, Switch, Port...',
        filter_status:      'Status:',
        filter_all:         'All ({count})',
        filter_active:      'Active',
        filter_gateway:     'Gateways',
        filter_switch_if:   'Switch Interfaces',
        no_hosts_in_subnet: 'No hosts recorded in this subnet.',
        no_search_results:  'No IP addresses matching your search.',
        col_ip:             'IP Address',
        col_mac:            'MAC Address',
        col_vendor:         'Vendor / Hardware',
        col_switch_port:    'Switch & Port',
        col_vlan:           'VLAN',
        col_status:         'Status',
        copy_ip:            'Copy IP',
        inspect_mac:        'Inspect MAC',
        showing_hosts:      'Showing {count} of {total} hosts',
        grid_select_hint:   'Select a specific subnet from the left panel to display the visual address matrix.',
        legend_active:      'Active Host',
        legend_gateway:     'Gateway / Router',
        legend_switch_if:   'Switch Interface',
        legend_free:        'Free IP',
        subnet_matrix_info: 'Subnet: {cidr} ({used} / {total} used)',
        free_ip_desc:       'Free IP Address',
        copied_clipboard:   'Copied to clipboard',
        vlans_title:        'VLANs & Trunks',
        vlans_count:        'VLANs ({count})',
        filter_vlans:       'Filter VLANs (ID, Name, Subnet, Switch, Port)...',
        vlan_configured_on: 'Configured on {count} switches/routers',
        vlan_no_results:    'No VLANs found matching your search.',
        vlan_hosts_count:   '{count} hosts',
        vlan_ports_count:   '{count} ports',
        vlan_access_ports:  'Access Ports',
        vlan_trunk_ports:   'Trunk Ports',
        vlan_svi_ports:     'SVIs / Routed',
        trunk_analyzer_title: 'Trunk Analyzer & Mismatches',
        trunk_matrix_title:   'Port-to-VLAN Matrix',
        trunk_directory_title:'VLAN Directory',
        total_trunks:         'Total Trunks',
        healthy_trunks:       'Healthy Trunks',
        native_mismatches:    'Native Mismatches',
        allowed_asymmetries:  'Allowed Asymmetries',
        orphan_vlans:         'Orphan VLANs',
        no_issues_detected:   'No Trunk or VLAN Inconsistencies Detected',
        all_trunks_clean:     'All switch-to-switch trunk native VLANs and allowed VLAN lists are perfectly aligned.',
        recommended_fix:      'Recommended CLI Remediation',
        copy_command:         'Copy Command',
        dns_integrity_title:  'DNS Integrity',
        dns_analyzer_title:   'DNS Integrity & Orphan Record Analyzer',
        dns_analyzer_subtitle:'Bidirectional verification of Forward (A) and Reverse (PTR) DNS records with dead/orphan record detection',
        dns_total_analyzed:   'Total Analyzed',
        dns_healthy_records:  'Healthy & Verified',
        dns_missing_ptr:      'Missing PTR',
        dns_mismatches:       'Forward/Reverse Mismatches',
        dns_orphan_records:   'Orphan A Records',
        dns_unresolved:       'Unresolved Devices',
        dns_resolver:         'DNS Resolver',
        dns_run_scan:         'Run DNS Scan',
        dns_scanning:         'Scanning DNS...',
        dns_filter_all:       'All Issues',
        dns_clean_title:      'All DNS Records Healthy & Verified',
        dns_clean_desc:       '100% of tested active IPAM hosts and devices have consistent forward and reverse DNS mappings.',
        dns_remediation:      'Recommended DNS Fix',
        dns_copy_fix:         'Copy DNS Fix',
        dhcp_scopes_title:    'DHCP Scopes & Leases',
        dhcp_scopes_subtitle: 'Multi-vendor DHCP scope telemetry, lease tracking, address pool exhaustion monitoring, and IPAM correlation',
        dhcp_total_scopes:    'Total Scopes',
        dhcp_pool_capacity:   'Pool Capacity',
        dhcp_active_leases:   'Active Leases',
        dhcp_free_leases:     'Available IPs',
        dhcp_pools_at_risk:   'Pools at Risk (>85%)',
        dhcp_avg_utilization: 'Avg Utilization',
        dhcp_sync_now:        'Sync DHCP Telemetry',
        dhcp_syncing:         'Syncing DHCP...',
        dhcp_add_scope:       'Add DHCP Scope',
        dhcp_tab_scopes:      'Address Pools',
        dhcp_tab_leases:      'Active Leases',
        dhcp_col_scope_name:  'Scope Name',
        dhcp_col_subnet:      'Subnet / Range',
        dhcp_col_server:      'DHCP Server',
        dhcp_col_utilization: 'Utilization',
        dhcp_col_leases:      'Active / Total',
        dhcp_col_lease_time:  'Lease Time',
        dhcp_col_status:      'Status',
        dhcp_col_actions:     'Actions',
        dhcp_col_expires:     'Expires In',
        dhcp_col_client_type: 'Type',
        dhcp_badge_scope:     'DHCP Scope',
        dhcp_badge_lease:     'DHCP Lease',
        dhcp_filter_scopes:   'Filter scopes (name, CIDR, server)...',
        dhcp_filter_leases:   'Filter leases (IP, MAC, vendor, hostname)...',
        dhcp_delete_confirm:  'Are you sure you want to delete this DHCP scope?',
        dhcp_modal_create_title: 'Create DHCP Scope',
        dhcp_modal_create_desc:  'Define a DHCP address pool scope for telemetry tracking and IPAM correlation.',
    },
    security: {
        title:              'Port Security & Rogue Device Detection',
        subtitle:           'Real-time MAC whitelisting, unauthorized rogue device detection, and switch port lockdown',
        scan_now:           'Scan Network Now',
        auto_baseline:      'Auto-Baseline All Discovered',
        add_rule:           'Add MAC Rule',
        refresh:            'Refresh',
        total_whitelisted:  'Whitelisted MACs',
        active_alerts:      'Active Rogue Alerts',
        port_violations:    'Port Violations',
        randomized_macs:    'Randomized / Private MACs',
        tab_alerts:         'Security Alerts',
        tab_whitelist:      'MAC Whitelist & Port Security',
        filter_all:         'All',
        filter_active:      'Active',
        filter_acknowledged:'Acknowledged',
        filter_resolved:    'Resolved',
        search_alerts:      'Search alerts by MAC, IP, switch, port, reason...',
        search_whitelist:   'Search whitelist by MAC, name, vendor, port...',
        col_severity:       'Severity',
        col_mac:            'MAC Address',
        col_device_name:    'Device / Hostname',
        col_vendor:         'Vendor / OUI',
        col_switch_port:    'Switch & Port',
        col_vlan:           'VLAN',
        col_type:           'Alert Type',
        col_occurrences:    'Count',
        col_last_seen:      'Last Detected',
        col_status:         'Status',
        col_actions:        'Actions',
        col_expected_port:  'Bound Port',
        col_expected_ip:    'Bound IP',
        btn_whitelist_now:  'Whitelist',
        btn_acknowledge:    'Acknowledge',
        btn_resolve:        'Resolve',
        btn_edit:           'Edit',
        btn_delete:         'Delete',
        type_rogue_device:  'Rogue Device',
        type_port_mismatch: 'Port Mismatch',
        type_ip_spoofing:   'IP Spoofing',
        type_randomized_mac:'Randomized MAC',
        status_whitelisted: 'Whitelisted',
        status_trusted:     'Trusted',
        status_blocked:     'Blocked',
        status_flagged:     'Flagged',
        badge_randomized:   'Private / Randomized MAC',
        no_alerts_found:    'No security alerts recorded. Network port security is clean.',
        no_whitelist_found: 'No MAC addresses found in whitelist. Run Auto-Baseline to import active devices.',
        modal_add_title:    'Add Device to MAC Whitelist',
        modal_edit_title:   'Edit MAC Whitelist Rule',
        field_mac:          'MAC Address (e.g. 00:11:22:33:44:55)',
        field_name:         'Device Name / Description',
        field_vendor:       'Vendor (Optional)',
        field_switch:       'Allowed Switch',
        field_port:         'Allowed Port (e.g. Gi0/1 - leave empty for any port)',
        field_ip:           'Allowed IP (Optional)',
        field_vlan:         'VLAN (Optional)',
        field_status:       'Security Status',
        field_comment:      'Notes / Comment',
        scan_started:       'Scanning network switches for unauthorized devices...',
        scan_completed:     'Scan finished: {scanned} switches scanned, {found} MACs analyzed, {rogues} rogue devices flagged.',
        baseline_confirm:   'Are you sure you want to Auto-Baseline all currently active devices? This will trust and lock all currently connected MAC addresses to their respective switch ports.',
        baseline_success:   'Successfully baselined {count} devices into MAC whitelist.',
        delete_confirm:     'Are you sure you want to remove this MAC address from the whitelist?',
        action_success:     'Action completed successfully',
    },
    syslog: {
        title:               'Central Syslog & SNMP Trap Receiver',
        subtitle:            'Real-time UDP 514 Syslog & UDP 162 SNMP Trap ingestion, Cisco mnemonic parsing, and instant event alerting',
        live_Pause:          'Live Stream Active',
        paused:              'Stream Paused',
        simulate:            'Simulate Event / Trap',
        clear_old:           'Purge Old Logs',
        total_messages:      'Total Stored Events',
        last_24h:            'Events (Last 24h)',
        critical_24h:        'Critical / Alert (24h)',
        warnings_24h:        'Warnings (24h)',
        syslog_vs_trap:      'Syslog vs SNMP Traps',
        top_categories:      'Top Event Categories:',
        search_placeholder:  'Search message, mnemonic (%LINK-3-UPDOWN), IP, hostname, interface...',
        all_protocols:       'All Protocols',
        all_devices:         'All Devices',
        all_categories:      'All Categories',
        all_severities:      'All Severities',
        Critical_only:       'Critical & Alert Only (Sev 0-3)',
        warnings_and_up:     'Warning & Higher (Sev 0-4)',
        notifications_and_up:'Notice & Higher (Sev 0-5)',
        info_and_up:         'Informational & Higher (Sev 0-6)',
        col_time:            'Timestamp',
        col_protocol:        'Protocol',
        col_severity:        'Severity',
        col_device:          'Source Device',
        col_category:        'Category',
        col_mnemonic:        'Mnemonic / Trap OID',
        col_message:         'Event Message',
        no_messages:         'No Syslog or SNMP Trap messages matching your filter criteria.',
        no_messages_hint:    'Point your routers/switches to UDP port 514 (Syslog) or UDP port 162 (SNMP Traps), or click "Simulate Event / Trap" to test.',
        showing_count:       'Showing {shown} of {total} messages',
        simulate_desc:       'Inject a realistic Syslog datagram or SNMP Trap PDU into the receiver pipeline to verify parsing, categorization, and instant alerting.',
        preset_template:     'Preset Event Template',
        protocol:            'Protocol',
        source_device:       'Source Device',
        custom_ip:           'Custom / External IP',
        source_ip:           'Source IP Address',
        hostname:            'Hostname',
        severity:            'Severity Level',
        category:            'Event Category',
        mnemonic:            'Cisco Mnemonic / Identifier',
        interface_opt:       'Interface (Optional)',
        message_body:        'Syslog Message / Trap Summary',
        send_simulation:     'Inject Simulated Event',
        sim_sent_title:      'Event Injected',
        sim_sent_desc:       'Simulated Syslog/Trap message processed and stored.',
        cleared_title:       'Logs Purged',
        cleared_desc:        'Removed {count} historical log entries.',
        detail_title:        'Event & Packet Inspection',
        trap_oid:            'SNMP Trap OID',
        raw_payload:         'Raw Wire Payload / VarBinds',
    },
    topology: {
        title:               'Network Topology',
        subtitle:            'Auto-discovered L2/L3 network topology & switch port wiring based on CDP, LLDP, and SNMP interface telemetry',
        nodes_count:         '{count} nodes',
        links_count:         '{count} active links',
        ports_count:         '{count} wired ports',
        view_mode:           'Map View:',
        view_wiring:         'Switch & Device Wiring',
        view_chassis:        'Switch Faceplate Rack',
        view_ports:          'Port Wiring & Cables',
        view_graph:          'Interactive Force Graph',
        view_matrix:         'Port Patch Matrix',
        filter_all:          'All',
        filter_switches:     'Switches',
        filter_routers:      'Routers',
        filter_managed:      'Monitored',
        search_placeholder:  'Filter nodes, ports, aliases, or IPs...',
        reset_layout:        'Reset Layout',
        refresh_scan:        'Rescan Topology',
        scanning:            'Scanning CDP/LLDP neighbors & switch port telemetry...',
        legend_title:        'Topology Legend',
        legend_monitored:    'Monitored (SNMP UP)',
        legend_external:     'CDP/LLDP Neighbor',
        legend_offline:      'Warning / Offline',
        status_label:        'Node Status',
        status_monitored:    'Monitored Device',
        status_external:     'Discovered Neighbor (CDP/LLDP)',
        type_label:          'Equipment Type',
        vendor_model:        'Vendor & Model',
        open_in_devices:     'Open in Devices',
        connected_links:     'Connected Links & Ports ({count})',
        local_port:          'Local Port',
        remote_port:         'Remote Port',
        port_alias:          'Port Description / Alias',
        connected_device:    'Connected Device / Peer',
        protocol:            'Protocol',
        speed_traffic:       'Speed & Live Traffic',
        switch_chassis_desc: 'Active physical & LAG ports with CDP/LLDP neighbors and SNMP interface descriptions',
        show_all_ports:      'Show All Active Labeled Ports',
        show_cdp_only:       'CDP / LLDP Neighbors Only',
        no_links_found:      'No topology links matching current filter.',
        unidentified_peer:   'Active Link (No CDP/Alias)',
        external_peers:      'Discovered Connected Equipment & Endpoints',
    },
    doc: {
        title:                'Network Documentation (HLD & LLD)',
        subtitle:             'Comprehensive live architecture and technical engineering specification generated directly from SNMP telemetry',
        tab_hld:              'High-Level Design (HLD)',
        tab_lld:              'Low-Level Design (LLD)',
        export_pdf:           'Print / Save PDF',
        export_md:            'Download Markdown',
        export_csv:           'Export CSV',
        refresh:              'Refresh Telemetry',
        generated_at:         'Generated At:',
        summary_devices:      'Total Devices',
        summary_online:       'Online Devices',
        summary_ports:        'Physical Ports',
        summary_active_ports: 'Active Ports',
        summary_subnets:      'IPAM Subnets',
        summary_hosts:        'Active Hosts',
        layers_title:         'Network Layers Architecture',
        layers_desc:          'Hierarchical classification of network infrastructure (Core, Spine, Leaf, Access, WAN)',
        ipam_title:           'Global IPAM Subnet Scheme (/24 and split subnets)',
        routing_title:        'Routing & Overlay Protocols (BGP EVPN, OSPF, VXLAN)',
        diagram_title:        'Topological Architecture Diagram',
        hardware_title:       'Hardware Inventory (BOM - Bill of Materials)',
        hardware_desc:        'Chassis models, serial numbers, firmware versions, dual power supplies and cooling fans',
        patch_title:          'Complete Port & Patch Matrix',
        patch_desc:           'Overview of all physical and logical interfaces, speeds, VLANs, and connected neighbor peers',
        optics_title:         'Optical SFP Power Budget & Levels',
        optics_desc:          'Transceiver optical telemetry (Rx/Tx power dBm, laser bias current mA)',
        search_placeholder:   'Search table...',
        filter_all:           'All Layers',
        all_status:           'All Statuses',
        device:               'Device',
        ip_address:           'IP Address',
        model:                'Model',
        vendor:               'Vendor',
        serial:               'Serial Number',
        os_version:           'OS Version',
        uptime:               'Uptime',
        status:               'Status',
        psu1:                 'PSU 1',
        psu2:                 'PSU 2',
        fans:                 'Fans',
        temp:                 'Temp',
        cpu_ram:              'CPU / RAM',
        port:                 'Port',
        alias:                'Port Alias / Description',
        vlan:                 'VLAN',
        speed:                'Speed',
        duplex:               'Duplex',
        remote_device:        'Connected Neighbor',
        remote_port:          'Remote Port',
        protocol:             'Protocol',
        tx_power:             'Tx Power',
        rx_power:             'Rx Power',
        bias_current:         'Laser Bias',
        signal_health:        'Signal Quality',
        bgp_peers:            'BGP Sessions & Peering',
        ospf_neighbors:       'OSPF Neighbor Adjacencies',
        vxlan_vnis:           'EVPN VXLAN VNIs & NVE Tunnels',
        peer_ip:              'Peer IP',
        remote_as:            'Remote AS',
        bgp_state:            'Session State',
        neighbor_id:          'Neighbor ID',
        router_id:            'Router ID',
        ospf_state:           'OSPF State',
        vni_id:               'VNI ID',
        vlan_id:              'VLAN ID',
        nve_if:               'NVE Interface',
        vni_state:            'VNI Status',
        copied_clipboard:     'Copied to clipboard!',
    },
    sensor_action: {
        ack_title:           'Acknowledge Sensor Alert',
        ack_title_edit:      'Edit Sensor Acknowledgment',
        pause_title:         'Pause Sensor Polling',
        resume_title:        'Resume Sensor Polling',
        recorded_operator:   'Recorded Operator',
        logged_in:           'Logged In',
        comment_label_ack:   'Acknowledgment Comment / Reason',
        comment_label_pause: 'Reason / Maintenance Note',
        visible_to_team:     'Visible to team',
        comment_ph_ack:      'e.g. Link maintenance in progress, ISP reported outage, hardware replacement...',
        comment_ph_pause:    'e.g. Scheduled device maintenance, temporarily offline for testing...',
        btn_clear_ack:       'Clear ACK',
        btn_ack:             'Acknowledge Sensor',
        btn_update_comment:  'Update Comment',
        btn_pause:           'Pause Polling',
        btn_resume:          'Resume Polling',
        btn_resume_now:      'Resume Now',
        btn_acked:           'ACKed',
        acked_by:            'ACK by',
        paused_by:           'Paused by',
        no_comment:          'No comment provided',
        banner_acked:        'Sensor Alert Acknowledged',
        banner_paused:       'Sensor Polling Paused',
        edit_comment:        'Edit Comment',
        clear_ack:           'Clear ACK',
        success_ack:         'Sensor alert acknowledged',
        success_unack:       'Sensor acknowledgment cleared',
        success_pause:       'Sensor polling paused',
        success_resume:      'Sensor polling resumed',
        presets: {
            maintenance:       'Scheduled network maintenance in progress',
            isp_outage:        'ISP outage - ticket opened with carrier',
            hardware_replace:  'Awaiting hardware / SFP replacement',
            known_issue:       'Known issue - troubleshooting underway',
            investigating:     'Temporary alert - under active observation',
            pause_maintenance: 'Scheduled equipment maintenance',
            pause_testing:     'Temporarily paused for lab testing',
            pause_disabled:    'Device offline until further notice',
            pause_customer:    'Customer port decommissioned',
            pause_monitoring:  'Monitoring temporarily paused',
        },
    },
    inspector: {
        title_up:           'Healthy Sensors & Devices (UP)',
        title_down:         'Critical / Outage Sensors (DOWN)',
        title_warning:      'Warning & Degraded Sensors (WARN)',
        title_ack:          'Acknowledged Sensors (ACK)',
        title_paused:       'Paused / Maintenance Sensors (PAUSED)',
        title_unknown:      'Unknown / Unpolled Sensors (UNKNOWN)',
        subtitle:           'Detailed sensor descriptions, telemetry readings, Acknowledge (ACK) & Pause comments, and operator actions.',
        matching:           'Matching',
        close_filter:       'Close Filter',
        search_placeholder: 'Search sensor, device, comment or user...',
        no_matching:        'No sensors or devices currently match status',
        th_status:          'Status',
        th_device:          'Device',
        th_sensor_name:     'Sensor / Node Name',
        th_type:            'Type',
        th_detail:          'Sensor Description & ACK / Pause Detail',
        th_reading:         'Current Reading',
        th_last_checked:    'Last Checked',
        th_actions:         'Actions',
        inspect:            'Inspect',
        clone_sensor:       'Clone Sensor',
        showing:            'Showing',
        of:                 'of',
        specs_title:        'Sensor Configuration & Thresholds',
        sensor_id:          'Sensor ID',
        check_interval:     'Check Interval',
        alarm_thresholds:   'Alarm Threshold Limits',
        edit_thresholds:    'Edit Thresholds / Sensor',
    },
    bgp: {
        session_uptime:        'Session Uptime',
        remote_as:             'Remote AS / Peer',
        asn_lookup_title:      'Autonomous System (ASN) Lookup',
        asn_lookup_btn:        'AS Lookup',
        asn_input_placeholder: 'Enter AS number (e.g. 13335, AS5448, 65400)...',
        quick_presets:         'Quick Presets:',
        querying_whois:        'Querying ASN WHOIS & Registry records...',
        private_as:            'Private AS',
        public_as:             'Public AS',
        network_type:          'Network Type',
        description:           'Description',
        external_tools:        'External BGP Looking Glass & Intelligence',
        lookup_as:             'Lookup AS',
        enter_valid_as:        'Please enter a valid AS number',
        asn_not_found:         'AS information could not be resolved',
        network_error:         'Network error querying ASN',
        resolving:             'Resolving...',
        established:           'Established',
    },
    scanner: {
        port_scan_title:      'Port Scanner & Services',
        port_scan_hint:       'Automatically discover open services (SSH, HTTP, DNS, Winbox, BGP) and add a sensor group',
        profile:              'Scan Profile',
        profile_well_known:   'Well-Known Services (~75 ports, <1s)',
        profile_common_1024:  'Standard Ports 1-1024 (~1s)',
        profile_top_1000:     'Top 1000 Ports (~2s)',
        scan_now:             'Scan Now',
        enter_ip_first:       'Please enter a device IP address before scanning',
        scan_failed:          'Port scan failed or unreachable',
        found_ports:          'Found {count} open ports ({duration} ms)',
        no_open_ports:        'No open ports found',
        open_ports_tab:       'Open Ports & Services',
        open_ports_title:     'Discovered Open Ports & Network Services',
        rescan_now:           'Scan Ports',
        add_all_as_sensors:   'Add All as Sensors',
        open_ports_count:     'Open Ports',
        scan_speed:           'Last Scan Duration',
        target_ip:            'Target IP Address',
        active_sensors:       'Active Port Sensors',
        search_placeholder:   'Search port, protocol or service (e.g. 80, SSH, HTTP)...',
        empty_hint:           'No open ports recorded yet for this device. Run a fast multi-threaded port scan.',
        start_scan:           'Start Port Scan',
        col_port:             'Port / Protocol',
        col_service:          'Service',
        col_description:      'Service Description',
        col_latency:          'Latency',
        col_version:          'Software Version',
        col_banner:           'Banner / Header',
        dns_hostname:         'Reverse DNS (PTR)',
        detected_os:          'Detected OS / Platform',
        resolving_dns:        'Resolving DNS...',
        apply_dns_name:       'Use as node name',
        col_status:           'Status',
        col_action:           'Tree Sensor',
        sensor_active:        'Sensor Active',
        create_sensor:        'Add Sensor',
        scan_completed:       'Found {count} open ports in {duration}ms',
    },
    proxmox: {
        loading:              'Loading Proxmox VE telemetry and virtual instances...',
        connect_error_title:  'Failed to connect to the Proxmox VE API',
        retry:                'Try again',
        connected_token:      'Connected (API Token)',
        refresh:              'Refresh telemetry',
        sync_sensors:         'Sync sensors',
        node_memory:          'Node Memory',
        storage_kpi:          'Storage (Pools)',
        stopped_count:        '{count} Stopped',
        lxc_containers:       'LXC Containers',
        storage_title:        'Storage Pools',
        active_pools:         '{count} active pools',
        utilization:          'Utilization',
        used:                 'Used: {value}',
        total:                'Total: {value}',
        guests_title:         'Virtual Instances (VM & LXC)',
        instances_count:      '{count} instances',
        filter_all:           'All',
        filter_all_types:     'All types',
        search_placeholder:   'Search by name or VMID...',
        col_name:             'Instance Name',
        col_type:             'Type',
        no_guests:            'No virtual machines or containers match the selected filters.',
        fetch_failed:         'Failed to fetch Proxmox telemetry',
        api_unavailable:      'Proxmox API is not reachable',
        server_error:         'Error communicating with the server',
        sync_failed:          'Failed to sync Proxmox sensors: {error}',
        sync_success:         'Proxmox sensors and virtual instances synced successfully!',
        sync_error:           'Sync error: {error}',
        unknown_error:        'Unknown error',
        integration_title:    'Proxmox VE Integration',
        integration_hint:     'Monitor the PVE node, storage pools, QEMU VMs and LXC containers over the HTTPS API (port 8006)',
        ignore_ssl:           'Ignore self-signed SSL certificate',
        token_id_placeholder: "e.g. monitoring{'@'}pve!nervuseye",
        test_connection:      'Test Proxmox API connection',
        connected:            'Connected to Proxmox VE!',
        connect_failed:       'Failed to connect to Proxmox VE',
        test_failed:          'API connection test failed',
        col_ip:               'IP Address',
        col_agent:            'QEMU Agent',
        agent_active:         'Agent Active',
        agent_stopped:        'Agent Stopped',
        agent_not_installed:  'No Agent',
        agent_lxc:            'LXC Native',
        ip_copied:            'IP address copied',
        no_ip:                'No IP detected',
        ram_allocated:        'RAM (Memory)',
        disk_allocated:       'Disk (Storage)',
        filesystems:          'Filesystem Mounts',
        os_info:              'Operating System',
        copy_ip:              'Click to copy IP',
    },
    hyperv: {
        loading:              'Loading Hyper-V host telemetry and virtual machines...',
        connect_error_title:  'Failed to connect to Hyper-V host over WinRM',
        retry:                'Try again',
        connected_winrm:      'Connected (WinRM PowerShell)',
        refresh:              'Refresh telemetry',
        sync_sensors:         'Sync sensors',
        host_memory:          'Host Memory',
        logical_processors:   'Logical CPUs',
        switches_title:       'Virtual Switches',
        vms_title:            'Virtual Machines (Hyper-V)',
        vms_count:            '{count} VMs',
        filter_all:           'All',
        filter_running:       'Running',
        filter_stopped:       'Stopped / Saved',
        search_placeholder:   'Search VM by name, IP, or switch...',
        col_name:             'VM Name',
        col_state:            'State',
        col_vcpu:             'vCPUs & Load',
        col_memory:           'Memory (Demand / Assigned)',
        col_network:          'Network (IP / MAC / Switch)',
        col_disks:            'Virtual Disks (VHD)',
        col_uptime:           'Uptime',
        no_vms:               'No virtual machines match the selected filter.',
        sync_success:         'Hyper-V host and VM sensors provisioned successfully!',
        sync_failed:          'Failed to sync Hyper-V sensors: {error}',
        integration_title:    'Microsoft Hyper-V Integration',
        integration_hint:     'Monitor Hyper-V host, virtual switches and VMs over WinRM (port 5985/5986)',
        port_label:           'WinRM Port',
        username_label:       'Windows User / Domain Account',
        password_label:       'Password',
        use_https:            'Use HTTPS WinRM (port 5986)',
        ignore_ssl:           'Ignore SSL Certificate Errors',
        test_connection:      'Test WinRM Connection',
        connected:            'Connected to Hyper-V host!',
        connect_failed:       'Failed to connect to Hyper-V host',
    },
    tools: {
        page_title:              'Network & System Diagnostics Suite',
        page_subtitle:           'Comprehensive network diagnostic tools, domain security validation (SPF, DKIM, DMARC), and BGP / RPKI routing inspection',
        category_network:        'Network Tools',
        category_security:       'Email & Domain Security',
        category_bgp:            'BGP & RPKI Routing',
        target_host:             'Target Host / IP Address',
        packet_count:            'Packet Count',
        run_ping:                'Run ICMP Ping',
        pinging:                 'Pinging target...',
        ping_title:              'Live ICMP / TCP Ping',
        ping_subtitle:           'Packet loss, round-trip latency, jitter and TTL analysis',
        execution_failed:        'Diagnostic execution failed',
        resolved_ip:             'Resolved IP',
        packets:                 'Packets (Recv/Sent)',
        packet_loss:             'Packet Loss',
        min_rtt:                 'Min RTT',
        avg_rtt:                 'Avg RTT',
        max_rtt:                 'Max RTT',
        icmp_packets_sequence:   'ICMP Packet Sequence',
        total_time:              'Total execution time: {ms} ms',
        traceroute_title:        'Traceroute & MTR Path Analyzer',
        traceroute_subtitle:     'Hop-by-hop latency, reverse PTR hostname resolution and Autonomous System (ASN) lookup',
        max_hops:                'Max Hops',
        run_traceroute:          'Start Traceroute',
        tracing:                 'Tracing route...',
        destination_reached:     'Target Reached',
        incomplete_trace:        'Incomplete Trace',
        total_hops:              '{count} hops traversed',
        dns_title:               'DNS Query & Dig Inspector',
        dns_subtitle:            'Direct queries for A, AAAA, CNAME, MX, TXT, NS, PTR, SOA, and SRV records with custom name servers',
        domain_or_ip:            'Domain Name or IP',
        record_type:             'Record Type',
        dns_server:              'Nameserver Resolver',
        query_dns:               'Query DNS',
        resolving:               'Querying nameserver...',
        dns_query_failed:        'DNS query failed',
        server_used:             'Resolver Server',
        response_time:           'Query Response Time',
        records_returned:        'Records Returned',
        no_records_found:        'No DNS records found for this query and record type.',
        port_scanner_title:      'Port Scanner & TCP Service Probe',
        port_scanner_subtitle:   'Multi-port connectivity check, latency measurement, and service banner grabbing',
        port_preset:             'Port Presets',
        custom_port_spec:        'Port Specification (comma-separated or ranges)',
        scan_ports:              'Scan Ports',
        scanning_ports:          'Scanning ports...',
        scan_failed:             'Port scan failed',
        target_ip:               'Target IP',
        scanned_ports:           'Scanned Ports',
        open_ports:              'Open Ports',
        duration:                'Scan Duration',
        whois_title:             'WHOIS Domain & IP Directory',
        whois_subtitle:          'Registrar, ownership, registration timeline, and nameserver verification',
        lookup_whois:            'Lookup WHOIS',
        looking_up:              'Looking up record...',
        whois_failed:            'WHOIS query failed',
        subnet_calc_title:       'Subnet Calculator & Mask Explorer',
        subnet_calc_subtitle:    'CIDR prefix mathematics, usable host boundaries, wildcard, and binary bit allocation',
        ip_or_cidr:              'IP Address or CIDR',
        subnet_mask:             'Subnet Mask',
        spf_title:               'SPF Record Inspector & Sender IP Simulator',
        spf_subtitle:            'RFC 7208 syntax check, 10 DNS lookup limit validation, and IP authorization simulation',
        domain:                  'Domain Name',
        test_sender_ip:          'Test Sender IP (Optional)',
        check_spf:               'Validate SPF',
        checking:                'Validating policy...',
        spf_failed:              'SPF check failed',
        dkim_title:              'DKIM Public Key & Selector Validator',
        dkim_subtitle:           'Validates DKIM DNS records, cryptographic public keys, and flags weak 1024-bit RSA keys',
        check_dkim:              'Validate DKIM',
        dmarc_title:             'DMARC Policy & Enforcement Inspector',
        dmarc_subtitle:          'Evaluates DMARC anti-spoofing policy, aggregate reporting (RUA), and security grade',
        check_dmarc:             'Inspect DMARC',
        smtp_title:              'SMTP & MX Mailserver Diagnostic',
        smtp_subtitle:           'Tests mail delivery servers, TCP port 25 connectivity, banner, and STARTTLS encryption',
        test_smtp:               'Test SMTP',
        testing:                 'Testing connection...',
        tls_cert_title:          'SSL / TLS Certificate Inspector',
        tls_cert_subtitle:       'Validates certificate expiration, Subject Alternative Names (SANs), CA issuer, and TLS ciphers',
        inspect_cert:            'Inspect Certificate',
        inspecting:              'Inspecting TLS handshake...',
        bgp_lookup_title:        'BGP Route, Prefix & RPKI Lookup',
        bgp_lookup_subtitle:     'Announced prefix, origin AS, cryptographic RPKI ROA validation, and IRR route objects',
        ip_or_prefix:            'IP Address or CIDR Prefix',
        lookup_route:            'Lookup BGP Route',
        querying_bgp:            'Querying global BGP routing...',
        lookup_failed:           'BGP routing query failed',
        asn_explorer_title:      'Autonomous System (ASN) Explorer',
        asn_explorer_subtitle:   'Origin network operator, announced IPv4 & IPv6 routing table size, and transit peers',
        asn_number:              'AS Number (e.g. AS15169)',
        lookup_asn:              'Lookup ASN',
        rpki_validator_title:    'RPKI Cryptographic ROA Validator',
        rpki_validator_subtitle: 'Verifies whether an origin Autonomous System is cryptographically authorized to announce a prefix',
        prefix:                  'CIDR Prefix',
        validate_rpki:           'Validate RPKI ROA',
        validating:              'Validating cryptographic ROA...',
        bgp_looking_glass_title:    'Public Router Viewers & BGP Paths (Looking Glass)',
        bgp_looking_glass_subtitle: 'Real-time global BGP routing table paths across RouteViews, Twelve99 / Arelion, Cogent, and RIPE RIS route collectors',
        query_paths:                'Query Live BGP Paths',
        querying_paths:             'Collecting real-time BGP paths...',
        filter_all:                 'All Viewers',
        filter_twelve99:            'Twelve99 (Arelion AS1299)',
        filter_cogent:              'Cogent (AS174)',
        filter_tier1:               'Tier-1 Transit Backbones',
        filter_routeviews:          'RouteViews Collectors',
        filter_ripe:                'RIPE RIS Collectors',
        external_viewers:           'Public Looking Glasses & Direct Router Access',
        as_path_flow:               'AS-Path Flow',
        collector_location:         'Collector & Location',
        peer_router:                'Peer Router',
        communities:                'BGP Communities',
    },
}
